import dayjs from 'dayjs';

/**
 * internalSharedConfig adds dynamic values to the shared config defined on Strapi.
 * These values will be available in questionnaires built on Strapi (e.g. to define a rule checking a numeric answer against the current year).
 */
const internalSharedConfig = {
  currentYear: dayjs().year(),
};

export default internalSharedConfig;
